import React from 'react';
import {
  ResponsiveContainer,
  PieChart as RechartsPieChart,
  Pie,
  Cell,
} from 'recharts';
import styled from 'styled-components/macro';
import { FlexWrapper, SPACINGS } from '../../utils';

const SmallPieChartPlaceholder = styled.div<{ width?: number }>`
  width: ${(p) => `${p.width}px`};
  height: 100%;
  border: ${SPACINGS[5]} solid ${(p) => p.theme.colors.secondary90w};
  border-radius: 50%;
`;

type SmallPieChartProps = {
  data: any[];
  dataKey: string;
  dataColors: string[];
  label?: React.ReactNode;
  innerRadiusPercentage?: string;
};

function SmallPieChart(props: SmallPieChartProps) {
  const {
    data,
    dataKey,
    dataColors,
    label,
    innerRadiusPercentage = '85%',
  } = props;

  if (!data || data.length === 0) {
    return <SmallPieChartPlaceholder />;
  }

  return (
    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
      {label && (
        <FlexWrapper
          direction="column"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          {label}
        </FlexWrapper>
      )}
      <ResponsiveContainer>
        <RechartsPieChart>
          <Pie
            data={data}
            innerRadius={innerRadiusPercentage}
            outerRadius="100%"
            paddingAngle={1}
            dataKey={dataKey}
            startAngle={450}
            endAngle={90}
          >
            {data.map((_, index) => (
              <Cell key={`cell-${index}`} fill={dataColors[index]} />
            ))}
          </Pie>
        </RechartsPieChart>
      </ResponsiveContainer>
    </div>
  );
}

export default SmallPieChart;
